var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleTickGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5868_14307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1295 11.8066C24.1295 5.38472 18.9217 0.17691 12.4998 0.17691C6.07793 0.17691 0.870117 5.38472 0.870117 11.8066C0.870117 18.2285 6.07793 23.4363 12.4998 23.4363C18.9217 23.4363 24.1295 18.2285 24.1295 11.8066Z",
    fill: "#D0CDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9026 8.10448C18.6308 7.39667 18.0729 7.50917 17.4683 7.63104C17.1073 7.70604 15.4995 8.17479 12.9636 10.856C11.9089 11.967 11.2151 12.8529 10.7558 13.5279C10.4745 13.1857 10.1558 12.8154 9.81825 12.4826C8.78232 11.4467 7.6245 10.7342 7.57763 10.706C7.09482 10.4107 6.462 10.5607 6.162 11.0482C5.86669 11.531 6.01669 12.1639 6.4995 12.4639C6.50888 12.4685 7.50263 13.0826 8.35575 13.9404C9.22763 14.8123 10.0198 15.9935 10.0292 16.0076C10.2214 16.2982 10.5448 16.467 10.887 16.467C10.9433 16.467 11.0042 16.4623 11.0651 16.4529C11.4683 16.3826 11.787 16.0826 11.8854 15.6889C11.8901 15.6795 12.2979 14.5498 14.4495 12.281C16.1839 10.4482 17.3417 9.86698 17.7448 9.7076C17.7495 9.7076 17.7495 9.7076 17.7589 9.7076C17.7589 9.7076 17.7729 9.70292 17.7964 9.68885C17.8667 9.66073 17.9042 9.65135 17.9042 9.65135C17.8854 9.65604 17.8761 9.65604 17.8761 9.65604V9.65135C18.0636 9.57167 18.4104 9.42167 18.4151 9.41698C18.9354 9.19198 19.1089 8.62948 18.9026 8.10448Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5868_14307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTickGrey);
export default __webpack_public_path__ + "static/media/circle_tick_grey.151f58fd42d7787ade3d676d735e080e.svg";
export { ForwardRef as ReactComponent };